import { ActionMenu, IconButton } from '@teamsnap/snap-ui';
import { ActionType } from '@teamsnap/snap-ui/build/components/ActionMenu/ActionMenu.types';
import * as React from 'react';

export const ActionColumn = ({
  actions,
  testId,
}: {
  actions: ActionType[];
  testId?: string;
}) => (
    <div className={'sui-relative sui-inline-block'}>
      <ActionMenu
        trigger={
          <IconButton
            border
            icon="more_horiz"
            sentiment="neutral"
            data-testid={`${testId}-button`}
          />
        }
        align="left"
        actions={actions}
        data-testid={testId}
      />
    </div>
  );
